import { createContext } from 'react';

const AppStateContext = createContext(null);

export default AppStateContext;
